export default "__VITE_ASSET__TDPeGTR3__"